import { render, staticRenderFns } from "./ProgressText.vue?vue&type=template&id=03604f54&scoped=true&"
import script from "./ProgressText.vue?vue&type=script&lang=js&"
export * from "./ProgressText.vue?vue&type=script&lang=js&"
import style0 from "./ProgressText.vue?vue&type=style&index=0&id=03604f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03604f54",
  null
  
)

export default component.exports